'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { Link } from '@hc-frontend/core-ui';
import { zodResolver } from '@hookform/resolvers/zod';
import React, { useActionState, useRef } from 'react';
import { useForm } from 'react-hook-form';

import Recaptcha from '../../../presentation/atoms/recaptcha/recaptcha';
import getRecaptchaToken from '../../../utils/get-recaptcha-token';
import { type FormState, UserInputs } from './constants';
import { actionForm } from './form-action-server';
import FormContent from './form-content';

export default function Page() {
  const config = getClientApplicationConfig();

  const securedActionForm = async (_: FormState, formData: FormData) => {
    const token = await getRecaptchaToken(
      config.recaptcha.siteKey,
      'ccpa_request',
    );
    formData.append('grecaptcha_token', token);
    return actionForm(_, formData);
  };
  const [state, formSubmitHandler, isPending] = useActionState(
    securedActionForm,
    {
      _errors: [],
    },
  );

  const {
    register,
    formState: { errors: clientErrors },
  } = useForm<UserInputs>({
    mode: 'onSubmit',
    resolver: zodResolver(UserInputs),
  });

  const formRef = useRef<HTMLFormElement>(null);

  return (
    <>
      <Recaptcha />
      <form
        className="hc-stack-layout justify-center"
        ref={formRef}
        action={formSubmitHandler}
      >
        <FormContent
          register={register}
          clientErrors={clientErrors}
          state={state}
          isPending={isPending}
        />
      </form>
      <div className="mt-32-60">
        We take the protection of your personal data very seriously. In order to
        properly identify you, you must enter the exact email address and phone
        number previously provided on our website. If you believe the
        information entered here is correct, please send us an email at
        info@healthcare.com. For more information visit our{' '}
        <Link
          id="survey-pii-privacy-policy"
          href="https://www.healthcare.com/privacy-policy"
          rel="noreferrer noopener"
          target="_blank"
        >
          <b>
            <u>Privacy Policy Page</u>
          </b>
        </Link>
      </div>
    </>
  );
}
